import styles from './infoMessage.module.scss';
import { ReactComponent as InfoIcon } from 'icons/info.svg';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function InfoMessage(props) {
  const { show, onClose, message } = props;
  const { t } = useTranslation();

  const onClick = (event, reason) => {
    if ((reason && reason === 'backdropClick') || reason === 'escapeKeyDown') return;

    onClose();
  };

  return (
    <Modal open={show} onClose={onClick}>
      <div className={styles.info_modal}>
        <InfoIcon />
        {message && <p>{message}</p>}
        <Button
          data-testid="InfoMessageCloseButton"
          className={styles.info_modal__button}
          onClick={onClick}
          size="small"
          variant="contained">
          {t('warningMessage.dismiss')}
        </Button>
      </div>
    </Modal>
  );
}
